module.exports = __webpack_public_path__ + "img/1487749637.46d86b13.jpg";